// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3rCj6","root":"styles_root__2ss3T","element":"styles_element__1SQnN","full":"styles_full__2pcHU"};